<template>
  <div class="data-box">
    <div class="cut-box After" :class="istop==1?'contain-Before':''">
      <div class="cut-box-tit">价格预警情况</div>
      <table class="tables">
        <tr><th>&nbsp;</th>
          <th v-for="(item,index) in pricemon.slice().reverse()" :key="index" :title="item.year+'年'">{{ item.month }}月</th>
        </tr>
        <tr><td>&nbsp;</td>
          <td v-for="(item,index) in priceweek.slice().reverse()" :key="index" :title="item.tsWeek">第{{ item.weekOfMonth }}周</td>
        </tr>
        <tr v-for="(item,index) in pricedata" :key="index">
          <td>{{item.indexName}}</td>
          <td v-for="(items,idx) in (item.indexes).slice().reverse()" :key="idx" :title="items.diffVal"><em :class="items.diffVal>0?'col-g':(items.diffVal==0?'col-y':'')"></em></td>
        </tr>
      </table>
    </div>
    <div class="cut-box After" :class="istop==2?'contain-Before':''">
      <div class="cut-box-tit">负荷预警情况</div>
      <table class="tables">
        <tr><th>&nbsp;</th>
          <th v-for="(item,index) in loadmon.slice().reverse()" :key="index" :title="item.year+'年'">{{ item.month }}月</th>
        </tr>
        <tr><td>&nbsp;</td>
          <td v-for="(item,index) in loadweek.slice().reverse()" :key="index" :title="item.tsWeek">第{{ item.weekOfMonth }}周</td>
        </tr>
        <tr v-for="(item,index) in loaddata" :key="index">
          <td>{{item.indexName}}</td>
          <td v-for="(items,idx) in (item.indexes).slice().reverse()" :key="idx" :title="items.diffVal"><em :class="items.diffVal>0?'col-g':(items.diffVal==0?'col-y':'')"></em></td>
        </tr>
      </table>
    </div>
    <div class="cut-box After" :class="istop==3?'contain-Before':''">
      <div class="cut-box-tit">效益预警情况</div>
      <table class="tables">
        <tr><th>&nbsp;</th>
          <th v-for="(item,index) in benefitmon.slice().reverse()" :key="index" :title="item.year+'年'">{{ item.month }}月</th>
        </tr>
        <tr><td>&nbsp;</td>
          <td v-for="(item,index) in benefitweek.slice().reverse()" :key="index" :title="item.tsWeek">第{{ item.weekOfMonth }}周</td>
        </tr>
        <tr v-for="(item,index) in benefitdata" :key="index">
          <td>{{item.indexName}}</td>
          <td v-for="(items,idx) in (item.indexes).slice().reverse()" :key="idx" :title="items.diffVal"><em :class="items.diffVal>0?'col-g':(items.diffVal==0?'col-y':'')"></em></td>
        </tr>
      </table>
    </div>
    <div class="max-min">
      <p title="降"><em></em>降</p>
      <p title="平"><em class="col-y"></em>平</p>
      <p title="升"><em class="col-g"></em>升</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "left-module-two2",
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      pricedata:[],
      pricemon:[],
      priceweek:[],
      loaddata:[],
      loadmon:[],
      loadweek:[],
      benefitdata:[],
      benefitmon:[],
      benefitweek:[],
      istop:1
      }
    },
  mounted() {
    let $this=this;
    $this.getprice()
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.getprice()
    })
  },
  methods:{
    getprice(){
      let $this=this;
      const url = '/api-portal/ccf/industryMonitoring/price';
      this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.pricedata=datas;
          $this.pricemon=datas[0].indexes;
          $this.priceweek=datas[0].indexes;
        }
      },'json');
      $this.getload()
      $this.cutmonitor()
    },
    getload (){
      let $this=this
      const url = '/api-portal/ccf/industryMonitoring/load';
      this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.loaddata=datas;
          $this.loadmon=datas[0].indexes;
          $this.loadweek=datas[0].indexes;
        }
      },'json');
      $this.getbenefit()
    },
    getbenefit (){
      let $this=this
      const url = '/api-portal/ccf/industryMonitoring/benefit';
      this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.benefitdata=datas;
          $this.benefitmon=datas[0].indexes;
          $this.benefitweek=datas[0].indexes;
        }
      },'json')
    },
    handle(){
      if(this.istop>=3){
        this.istop=0
      }
      this.istop+=1
    },
    cutmonitor(){
      let $this=this;
      let tt=$this.istop
      setInterval(function (){
        if(tt>=3){
          tt = 0
        }
        tt+=1
        $this.istop=tt
      },16000)
    }
  }
}
</script>

<style scoped>
.data-box{
  width: 100%;
  height: 100%;
  position: relative;
}

.After{
  position: absolute;
  top:0;
  left: 0;
  transform: rotateY(-180deg);
  backface-visibility: hidden;
  transition: 2s;
}

.data-box .contain-Before{
  transform: rotateY(0deg);
}

.data-box .After:nth-child(2){
  transform: rotateX(-180deg);
}

.data-box .contain-Before:nth-child(2){
  transform: rotateX(0deg);
}

.max-min{
  min-width: 108px;
  position: absolute;
  right: 23px;
  top: 15px;
  color: #f0f0f0;
}

.max-min p{
  display: inline-block; margin: 0 5px;
}

.max-min em{
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
  width: 12px;height: 12px; border-radius: 12px; background: #D65532;
  border: 1px solid #A24126;box-shadow: 1px 3px 2px rgba(0,0,0,.6);
}

.cut-box {
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

.cut-box-tit{
  background: #061D43;
  color: #00D2E9;
  line-height: 40px;
  padding: 2px 25px;
  border-radius: 10px;
  box-shadow: 2px 5px 4px rgba(0,0,0,.9);
}

.tables {
  width:447px;
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#C9E2FF;
  border-width: 1px;
  border-color: #6D7889;
  border-collapse: collapse;
  background: url("../../../assets/bj-5.png") no-repeat center/100%;
}
.tables th {border-width: 1px;padding: 3px 9px;border-style: solid;border-color: #6D7889;}
.tables td {border-width: 1px;padding: 4px 9px 3px 9px;border-style: solid;border-color: #6D7889; text-align: center}
.tables td:first-child{text-align: right}
.tables em{width: 12px;height: 12px; border-radius: 12px; background: #D65532;display: inline-block; border: 1px solid #A24126;box-shadow: 1px 3px 2px rgba(0,0,0,.6);}
em.col-y{
  background: #EAC282;
  border: 1px solid #A68330;
}
em.col-g{
  background: #68A490;
  border: 1px solid #37725F;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/left-module-two2.vue